import { Hero } from "../components/site/Hero";
import { About } from "../components/site/About";
import { Pricing } from "../components/site/Pricing";
import { WhyUs } from "../components/site/WhyUs";
import { Process } from "../components/site/Process";
import { Testimonials, MarqueeBand } from "../components/site/Testimonials";
import { Faq } from "../components/site/Faq";
import { Contact } from "../components/site/Contact";

export default function Landing() {
  return (
    <main>
      <Hero />
      <MarqueeBand />
      <About />
      <Pricing />
      <WhyUs />
      <Process />
      <Testimonials />
      <Faq />
      <Contact />
    </main>
  );
}
